<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'quality-fabricIssues',
  components: {
    PageTable,
  },
}
</script>
